import { render, staticRenderFns } from "./bogus_op.vue?vue&type=template&id=98cef4fe&scoped=true&"
import script from "./bogus_op.vue?vue&type=script&lang=js&"
export * from "./bogus_op.vue?vue&type=script&lang=js&"
import style0 from "./bogus_op.vue?vue&type=style&index=0&id=98cef4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cef4fe",
  null
  
)

export default component.exports